import { ActivityMessage } from 'src/components/ActivityList/activity-list-item';
import { ActivityFeed } from 'src/graphql/entities/activity-feed/hooks/use-activity-feed';
import { buildAddressMessage } from './build-address-message';
import { buildClientMessage } from './build-client-message';
import { buildClientToAddressMessage } from './build-client-to-address-message';
import { buildConversationToAddressMessage } from './build-conversation-to-address-message';
import { buildProjectMessage } from './build-project-message';

export const buildMessagesByType = (activity: ActivityFeed): ActivityMessage[] => {
  switch (activity.entity) {
    case 'Address':
      return buildAddressMessage(activity);
    case 'ConversationToAddress':
      return buildConversationToAddressMessage(activity);
    case 'ClientToAddress':
      return buildClientToAddressMessage(activity);
    case 'Project':
      return buildProjectMessage(activity);
    case 'Client':
      return buildClientMessage(activity);
    default:
      return [];
  }
};
